/* ============================================================
   MFF — Consultation page wiring
   File: assets/mff-consult.js  (included from layout/theme.liquid)

   Model: pay & book up front, then a coach contacts the customer within
   24h to arrange a time. Every paid option goes straight to checkout,
   with a reassurance + confidence note under each booking CTA (except the
   30% promo button).

   1) Booking CTAs -> add to cart -> /checkout (fallback to product page):
        - Initial Consultation        (variant 49343875416410)
        - 'Claim 30% Off' first consult (variant 49343875416410 + FIRST30)
        - Full Programme              (variant 54273904148826)
        - Ongoing Coaching            (variant 54273896120666) [monthly:
          needs a subscription selling plan, else it charges once]
   2) 'Request Consultation' form (the 'not sure' path) -> emails the
      enquiry via Shopify contact + adds the person to the Klaviyo
      'Consultation Bookings' list, with a thank-you confirmation.
   ============================================================ */
(function(){
  var NOTE_TEXT='After booking, a coach will contact you within 24 hours to arrange a time that fits your schedule. You’re in good hands — we look forward to working with you.';

  function buy(id, fallback, discount){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.href = discount ? ('/checkout?discount='+encodeURIComponent(discount)) : '/checkout'; })
      .catch(function(){ window.location.href=fallback; });
  }
  function addNote(el){
    if(!el || !el.parentNode) return;
    if(el.parentNode.querySelector('.mff-book-note')) return;
    var n=document.createElement('div');
    n.className='mff-book-note';
    n.style.cssText='margin-top:10px;font-size:0.78rem;line-height:1.45;color:#6A5A50;max-width:360px;';
    n.textContent=NOTE_TEXT;
    el.parentNode.insertBefore(n, el.nextSibling);
  }
  function bookText(b){ return (b.textContent||'').replace(/\s+/g,' ').trim(); }

  var ACTIONS=[
    {re:/^start full programme$/i, id:54273904148826, fallback:'/products/full-programme-1'},
    {re:/^start coaching$/i, id:54273896120666, fallback:'/products/ongoing-coaching'},
    {re:/claim 30% off/i, id:49343875416410, fallback:'/products/video-analysis', discount:'FIRST30', noNote:true}
  ];
  function wireButtons(){
    var els=document.querySelectorAll('a,button');
    for(var j=0;j<els.length;j++){
      var b=els[j];
      if(b.__mffConsult) continue;
      var t=bookText(b);
      var act=null;
      for(var i=0;i<ACTIONS.length;i++){ if(ACTIONS[i].re.test(t)){ act=ACTIONS[i]; break; } }
      if(act){
        b.__mffConsult=true;
        (function(b,act){
          b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); buy(act.id, act.fallback, act.discount); });
        })(b,act);
        if(!act.noNote){ addNote(b); }
      }
    }
  }
  /* Initial Consultation: the 'Book Now' inside the one-time consultation card */
  function wireInitialConsult(){
    var cards=document.querySelectorAll('div,section,article');
    for(var i=0;i<cards.length;i++){
      var c=cards[i]; var t=c.textContent||'';
      if(/initial consultation/i.test(t) && /one[- ]?time/i.test(t) && t.length<800){
        var inner=c.querySelectorAll('a,button');
        for(var k=0;k<inner.length;k++){
          var b=inner[k];
          if(!b.__mffConsult && /^book now$/i.test(bookText(b))){
            b.__mffConsult=true;
            b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); buy(49343875416410,'/products/video-analysis'); });
            addNote(b);
            return;
          }
        }
      }
    }
  }

  /* ---- Request Consultation form -> email + Klaviyo ---- */
  var KLAVIYO_KEY='UuTeHS';
  var KLAVIYO_LIST='REZG3K';
  function v(id){ var e=document.getElementById(id); return e?(e.value||'').trim():''; }
  function showResult(text, ok){
    var btn=document.getElementById('mff-submit-btn'); if(!btn) return;
    var m=document.getElementById('mff-form-result');
    if(!m){ m=document.createElement('div'); m.id='mff-form-result'; m.style.cssText='margin-top:12px;font-size:0.9rem;font-weight:600;line-height:1.4;'; btn.parentNode.insertBefore(m, btn.nextSibling); }
    m.style.color = ok ? '#1A6B4A' : '#be123c';
    m.textContent=text;
  }
  function toKlaviyo(first,last,email,service){
    try{
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_KEY,{
        method:'POST',
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email,first_name:first,last_name:last,properties:{'Requested Service':service||'','Source':'Consultation page'}}}}},relationships:{list:{data:{type:'list',id:KLAVIYO_LIST}}}}})
      }).catch(function(){});
    }catch(e){}
  }
  function submitRequest(e){
    e.preventDefault(); e.stopPropagation();
    var first=v('mff-first-name'), last=v('mff-last-name'), email=v('mff-email');
    var service=v('mff-service'), message=v('mff-message');
    var coach=v('mff-coach-field'), pain=v('mff-pain-field'), perf=v('mff-perf-field');
    if(!first || !/.+@.+\..+/.test(email)){ showResult('Please add your first name and a valid email address.', false); return; }
    var btn=document.getElementById('mff-submit-btn'); var orig=btn.textContent;
    btn.textContent='Sending…'; btn.style.pointerEvents='none'; btn.style.opacity='0.7';
    toKlaviyo(first,last,email,service);
    var body='New consultation request\n\nName: '+first+' '+last+'\nEmail: '+email+'\nService: '+(service||'-')+'\nPreferred coach: '+(coach||'No preference')+'\nIn pain: '+(pain||'-')+'\nPerformance related: '+(perf||'-')+'\n\nMessage:\n'+(message||'-');
    var fd=new FormData();
    fd.append('form_type','contact'); fd.append('utf8','✓');
    fd.append('contact[name]', (first+' '+last).trim());
    fd.append('contact[email]', email);
    fd.append('contact[body]', body);
    fetch('/contact',{method:'POST', body:fd, headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(){ showResult('Thanks — your request has been sent. We’ll be in touch within 24 hours.', true); })
      .catch(function(){ showResult('Sorry, something went wrong. Please email info@myfootfunction.com.', false); })
      .finally(function(){ btn.textContent=orig; btn.style.pointerEvents=''; btn.style.opacity=''; });
  }
  function wireForm(){
    var btn=document.getElementById('mff-submit-btn');
    if(btn && !btn.__mffSubmit){ btn.__mffSubmit=true; btn.addEventListener('click', submitRequest); }
  }

  function init(){ wireButtons(); wireInitialConsult(); wireForm(); }
  init();
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); }
  window.addEventListener('load', init);
})();
